<template>
  <div class="index-page">
    <header-cmp></header-cmp>

    <!-- banner图 开始-->
    <!-- <section class="page-part banner banner_index"> -->
    <section class="page-part">
      <el-carousel
        class="page-part"
        height="500px"
        trigger="hover"
        indicator-position="outside"
      >
        <el-carousel-item v-for="banner in banners" :key="banner.index">
          <!-- <img :class="banner" :src="banner.src" :alt="banner.alt"> -->
          <div
            :class="
              `banner banner-0${banner.index} ${
                banner.redirect || banner.url ? 'pointer' : ''
              } `
            "
          ></div>
          <div
            class="banner-cover"
            v-show="banner.url"
            @click="bannerClick(banner)"
          >
            <i class="icon icon-play"></i>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- banner图 结束-->

    <!-- 询价发货按钮 开始-->
    <section id="inquiry" class="page-part bg">
      <div class="page-inner user-buttons">
        <div
          class="deliver-bg user-button"
          @click="$router.push({ name: 'deliver', query: { nodump: true } })"
        >
          <div class="deliver icon"></div>
          <div class="text inline-block">
            <h3 class="title">立即发货</h3>
            <p class="desc">点击发布，选合适的司机</p>
          </div>
        </div>
        <div
          class="inquiry-bg user-button"
          @click="$router.push({ name: 'inquiry', query: { nodump: true } })"
        >
          <div class="inquiry icon"></div>
          <div class="text inline-block">
            <h3 class="title">立即询价</h3>
            <p class="desc">价格预估，运货无忧</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 询价发货按钮 结束-->

    <!-- 成交记录    开始 -->
    <section id="record" class="page-part record">
      <div class="page-inner">
        <h3 class="text-primary record-title">成交记录</h3>
        <!-- 滚动条 -->
        <div class="scroll-part">
          <scroll-table-cmp :records="recordList"></scroll-table-cmp>
        </div>
        <!-- 滚动条 -->

        <!-- <div class="image-part">
          <div class="big-img"></div>
          <div class="small-img"></div>
          <div class="small-img"></div>
        </div> -->
      </div>
    </section>
    <!-- 成交记录    结束 -->

    <!-- 产品下载    开始 -->
    <section id="download" class="page-part download bg">
      <div class="page-inner">
        <h3 class="download-title">产品下载</h3>

        <!-- 下载卡片开始 -->
        <div class="card">
          <div class="card-top">
            <div class="icon huozhu"></div>
            <h1>我是货主</h1>
          </div>
          <div class="card-bottom">
            <div
              class="icon icon-qrcode icon-qrcode_huozhu card-bottom-left"
            ></div>
            <div class="card-bottom-right">
              <span>扫码下载安卓版/iOS版</span>
              <br />
              <button class="btn btn-download" @click="download('huozhu')">
                点击下载
              </button>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-top">
            <div class="icon siji"></div>
            <h1>我是司机</h1>
          </div>
          <div class="card-bottom">
            <div
              class="icon icon-qrcode icon-qrcode_siji card-bottom-left"
            ></div>
            <div class="card-bottom-right">
              <span>扫码下载安卓版/iOS版</span>
              <br />
              <button class="btn btn-download" @click="download('siji')">
                点击下载
              </button>
            </div>
          </div>
        </div>
        <!-- 下载卡片结束 -->
      </div>
    </section>
    <!-- 产品下载    结束 -->

    <!-- 合作伙伴    开始 -->
    <section id="partner" class="page-part partner">
      <div class="page-inner">
        <h3 class="partner-title">合作伙伴</h3>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
        <div class="icon logo"></div>
      </div>
    </section>
    <!-- 合作伙伴    结束 -->

    <footer-cmp></footer-cmp>

    <modal-cmp
      :open.sync="videoModalVisible"
      mode="video"
      :videoSrc="videoSrc"
    ></modal-cmp>
  </div>
</template>

<script type="text/ecmascript-6">
import HeaderCmp from '@/components/header';
import FooterCmp from '@/components/footer';
import ScrollTableCmp from '@/components/scroll-table';
import ModalCmp from '@/components/modal';

// model
import Record from '@/models/Record';

export default {
  name: 'indexPage',
  data() {
    return {
      recordList: [],
      videoSrc: 'http://www.clfirst.com/videos/ceo_introduction.6a89b70.mp4',
      videoModalVisible: false,
      banners: [
        { index: 1, redirect: '' },
        { index: 2, redirect: '', url: 'http://www.clfirst.com/videos/ceo_introduction.6a89b70.mp4' },
        { index: 3, redirect: '', url: 'http://www.clfirst.com/videos/xiangyun_introduction.e1f63fa.mp4' },
        // { index: 3, redirect: 'aboutus', query: { goAnchor: 'jianjie' } },
      ]
    }
  },
  components: {
    HeaderCmp,
    FooterCmp,
    ScrollTableCmp,
    ModalCmp
  },
  created() {
    this.$http.get('/shipper/order-inquiry/clinch-order').then(data => {
      this.recordList = data.data.list;
    }).catch(err => console.error(err.message));
  },
  mounted() {
    this.$utils.watchRouteGoAnchor(this);
  },
  methods: {
    download(type) {
      const a = document.createElement('a');
      a.target = '_blank';
      if (type === 'siji')
        a.href =
        'https://active.clewm.net/BKE2Le?qrurl=http://qr10.cn/BKE2Le&gtype=1&key=024791535e35c677e737224049ce66e9aabb8df577';
      else
        a.href =
        'https://active.clewm.net/B3Kyck?qrurl=http://qr10.cn/B3Kyck&gtype=1&key=8b05f155b4aeafbd6737228806f838e0a91b3c9624';
      document.body.appendChild(a);
      a.click();
    },

    bannerClick(banner) {
      if (banner.redirect) {
        this.$router.push({ name: banner.redirect, query: banner.query });
      }
      else if (banner.url) {
        this.videoModalVisible = true;
        this.videoSrc = banner.url;
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../style/_variable";
.index-page {
  width: 100%; // banner图
  .banner {
    height: 500px;
    &-01 {
      background: url("../assets/images/page_index/banner01.png") center
        no-repeat;
      background-size: 100% 100%;
      -moz-background-size: 100% 100%;
    }
    &-03 {
      background: url("../assets/images/page_index/banner02.jpg") center
        no-repeat;
      background-size: 100% 100%;
      -moz-background-size: 100% 100%;
    }
    &-02 {
      background: url("../assets/images/page_index/banner03.jpg") center
        no-repeat;
      background-size: 100% 100%;
      -moz-background-size: 100% 100%;
    }
  }

  .icon-play {
    width: 50px;
    height: 50px;
    background: url("../assets/images/icon/play.png") center no-repeat;
    background-size: 50px;
    opacity: 0.4;
    transition: all 0.5s;
  }
  .banner-cover {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.2);
    transition: all 0.5s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.4);
      .icon-play {
        opacity: 1;
      }
    }
  }

  .pointer {
    cursor: pointer;
  }

  .page-part.bg {
    background: $bg-clr;
  }
  // 询价发货按钮
  .user-buttons {
    text-align: center;
    .user-button {
      cursor: pointer;
      display: inline-block;
      width: 480px;
      height: 135px;
      padding: 26px 50px 26px 113px;
      .text {
        margin-left: 50px;
        .title {
          text-align: left;
          font-size: 24px;
          margin-top: 8px;
        }
        .desc {
          font-size: 14px;
          margin-top: 5px;
        }
      }

      &:hover {
        .title {
          color: $text-clr_primary;
        }
        .desc {
          color: $text-clr_primary;
        }
      }

      &:last-child {
        border-left: 2px solid white;
      }
    }
    .inquiry-bg {
      background: url("../assets/images/page_index/inquiry_bg.png") center
        no-repeat;
      &:hover {
        background-image: url("../assets/images/page_index/inquiry_active_bg.png");
        .inquiry {
          background-image: url("../assets/images/page_index/inquiry_active_icon.png");
        }
      }

      .inquiry {
        display: inline-block;
        vertical-align: top;
        background: url("../assets/images/page_index/inquiry_icon.png") center
          no-repeat;
        width: 90px;
        height: 83px;
        background-size: contain;
        &:hover {
          background-image: url("../assets/images/page_index/inquiry_active_icon.png");
        }
      }
    }
    .deliver-bg {
      background: url("../assets/images/page_index/deliver_bg.png") center
        no-repeat;
      &:hover {
        background-image: url("../assets/images/page_index/deliver_active_bg.png");
        .deliver {
          background-image: url("../assets/images/page_index/deliver_active_icon.png");
        }
      }

      .deliver {
        display: inline-block;
        vertical-align: top;
        background: url("../assets/images/page_index/deliver_icon.png") center
          no-repeat;
        width: 90px;
        height: 83px;
        background-size: contain;
      }
    }
  }
  .record {
    padding: 30px 0 20px 0;
    overflow: hidden;
    &-title {
      font-size: 18px;
      margin-bottom: 30px;
      font-weight: bold;
    }

    .scroll-part {
      vertical-align: top;
      float: left;

      width: 100%;
    }
    .image-part {
      vertical-align: top;
      float: right;
      .big-img {
        width: 450px;
        height: 270px;
        margin-bottom: 5px;
        background: url("../assets/images/page_index/img1.png") center no-repeat;
      }
      .small-img {
        display: inline-block;
        width: 225px;
        height: 166px;
        background: url("../assets/images/page_index/img2.png") center no-repeat;
        &:last-child {
          background: url("../assets/images/page_index/img3.png") center
            no-repeat;
        }
      }
    }
  }

  .download {
    padding: 30px 0 20px 0;
    overflow: hidden;
    &-title {
      font-size: 18px;
      margin-bottom: 30px;
      font-weight: bold;
      color: $text-clr_primary;
      margin-bottom: 30px;
    }

    .huozhu {
      display: inline-block;
      width: 90px;
      height: 90px;
      background: url("../assets/images/page_index/hz_icon.png") center
        no-repeat;
    }
    .siji {
      display: inline-block;
      width: 90px;
      height: 90px;
      background: url("../assets/images/page_index/sj_icon.png") center
        no-repeat;
    }

    .btn-download {
      width: 134px;
      height: 48px;
      color: white;
      border-radius: 6px;
      line-height: 1;
      margin-top: 20px;
      background: linear-gradient(180deg, #00cbfc 0%, #00a7f7 100%);
      &:active {
        background: linear-gradient(0deg, #00cbfc 0%, #00a7f7 100%);
      }
    }

    .card {
      background-color: #fff;
      padding: 30px 40px 30px 54px;
      width: 530px;
      height: 391px;
      float: left;
      &-top {
        border-bottom: 1px solid $border-clr;
        padding-bottom: 30px;
        .icon {
          margin-left: 60px;
        }
        h1 {
          float: right;
          font-size: 33px;
          margin-top: 20px;
          margin-right: 48px;
        }
      }

      &-bottom {
        margin-top: 30px;
        &-right {
          margin-top: 60px;
          margin-left: 60px;
          display: inline-block;
          vertical-align: top;
        }
        &-left {
          &.icon-qrcode {
            display: inline-block;
            &_huozhu:before {
              width: 180px;
              height: 180px;
              background-image: url("../assets/images/qrcode_huozhu.png");
              background-size: 180px;
            }
            &_siji:before {
              width: 180px;
              height: 180px;
              background-image: url("../assets/images/qrcode_siji.png");
              background-size: 180px;
            }
          }
        }
      }

      &:last-child {
        float: right;
      }
    }
  }

  .partner {
    padding: 30px 0 20px 0;
    overflow: hidden;
    &-title {
      font-size: 18px;
      margin-bottom: 30px;
      font-weight: bold;
      color: $text-clr_primary;
      margin-bottom: 30px;
    }

    .icon.logo {
      width: 180px;
      height: 80px;
      float: left;
      margin: 0 45px 50px -10px;
      background: url("../assets/images/logo/logo_1.png") center no-repeat;

      &:nth-child(3) {
        background-image: url("../assets/images/logo/logo_2.png");
      }
      &:nth-child(4) {
        background-image: url("../assets/images/logo/logo_3.png");
      }
      &:nth-child(5) {
        background-image: url("../assets/images/logo/logo_4.png");
      }
      &:nth-child(6) {
        background-image: url("../assets/images/logo/logo_5.png");
      }
      &:nth-child(7) {
        background-image: url("../assets/images/logo/logo_6.png");
      }
      &:nth-child(8) {
        background-image: url("../assets/images/logo/logo_7.png");
      }
      &:nth-child(9) {
        background-image: url("../assets/images/logo/logo_8.png");
      }
      &:nth-child(10) {
        background-image: url("../assets/images/logo/logo_9.png");
      }
      &:nth-child(11) {
        background-image: url("../assets/images/logo/logo_10.png");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue